      <template>

        <div class="about_main">
              <div class="main_banner">
                  <banner> </banner>
              </div>
             <div class="top_txt">联系我们</div>
             <div class="main_top">
                  <div class="tlt">
                       河北  |  石家庄
                   </div>

                    <p class="about_t">石家庄飞天科技开发有限公司</p>

                     <!-- <img style="width: 100px;margin: 0;float: right;" src="@/assets/images/weixin.jpg"/> -->

                     <p>
                      <i slot="prefix" class=" el-icon-phone-outline"></i><span>0311-85048504</span>
                     </p>

                     <p>
                           <i slot="prefix" class=" el-icon-phone-outline"></i><span>15226559123</span>
                     </p>

                     <p>
                           <i slot="prefix" class=" el-icon-message"></i><span>sjzftkj@126.com</span>
                     </p>


                     <p>
                           <i slot="prefix" class=" el-icon-location-information"></i><span>石家庄市槐安西路88号卓达中苑商务大厦B座305</span>
                     </p>


                     <div class="map">
                           <movemap></movemap>
                      </div>
             </div>





             <div class="main_bottom">

                  <div class="bot_t">
                        感谢您对飞天科技的关注，请填写以下信息，我们将在第一时间与您联系。
                  </div>


                 <el-form :model="form" label-width="100px">
                     <p class="input_p">
                        <el-input  class="input"
                        placeholder="姓名"
                        v-model="form.name">
                        <i slot="prefix" class="el-input__icon el-icon-s-custom"></i>
                      </el-input>
                     </p>


                   <p class="input_p">
                      <el-input
                        type="number"
                        placeholder="电话"
                        v-model="form.ipone">
                        <i slot="prefix" class="el-input__icon el-icon-phone-outline"></i>
                      </el-input>
                   </p>


                   <p class="input_p">
                      <el-input
                        placeholder="邮箱"
                        v-model="form.email">
                        <i slot="prefix" class="el-input__icon el-icon-message"></i>
                      </el-input>
                   </p>


                  <p class="input_p">
                      <el-input
                        placeholder="地址"
                        v-model="form.address">
                        <i slot="prefix" class="el-input__icon el-icon-location-information"></i>
                      </el-input>
                  </p>


                  <p class="">
                     <el-input
                     type="textarea"
                     placeholder="留言"
                     v-model="form.content">
                     <i slot="prefix" class="el-input__icon el-icon-edit-outline"></i>
                     </el-input>
                  </p>




                      <el-button type="primary" @click="save">提交</el-button>


                </el-form>

             </div>

        </div>
      </template>

      <script>


         export  default{
            data(){
                return{
                  form: {
                        name: "",
                        email:'',
                        address:'',
                        content:''
                        }
                }
            },
            methods: {
               save() {}
            }

         }

      </script>



      <style lang="less" scoped>

                  .top_txt{
                    text-align: center;
                    padding: 20px 0;
                    font-size: 24px;
                    color:#333;
                    position: relative;
                  }

                  .top_txt:before {
                      content: "";
                      position: absolute;
                      left: 50%;
                      bottom: 5px;
                      display: block;
                      width: 64px;
                      height: 3px;
                      background: #e50012;
                      margin-left: -32px;
                  }


      .about_main{
         text-align: left;
         background: #fff;
         padding:0 0 40px;


         .map{
            height: 160px;
            margin: 10px 0;
         }

         .main_top{
            padding: 15px;

            .about_t{
               margin-bottom:10px;
               font-size: 22px;

            }
            .tlt{
               padding: 10px 0 15px 0;
            }
            p{
               font-size: 16px;
               line-height: 30px;
               i{
                  margin-right: 5px;
               }
            }

            img{
               margin: 20px 0;
            }
         }



      }

      </style>


<style lang="less">
   .main_bottom{

      padding: 15px;

      .bot_t{
         font-size: 18px;
         line-height: 26px;
         text-align: center;
         padding: 20px 0 ;
      }

      p {
            margin-top: 20px;

            .el-input__inner{
            border: none ;
            padding: 0 4px 0 35px;
            background: #f0f0f0;

            }

      }

      .input_p{
            padding:5px 0;
            background: #f0f0f0;
            border-radius: 6px;
      }

      .el-button{
         margin-top: 20px;
         width: 50%;
         padding: 15px 0;
      }


      .el-form-item__content{
         margin-left: 0;
      }

      .el-input__icon{
         font-size:22px ;
      }
   }



</style>



// WEBPACK FOOTER //
// src/components/move/about.vue